import {Routes} from '@angular/router';
import {ConsultarComponent} from './consultar/consultar.component';
import {HistoricoComponent} from './historico/historico.component';
import {CadastroContratoArrendamentoComponent} from './cadastro-contrato-arrendamento/cadastro-contrato-arrendamento.component';
import {HistoricoContratoArrendamentoComponent} from './historico-contrato-arrendamento/historico-contrato-arrendamento.component';

export const veiculoRoutes: Routes = [
  {
    path: '',
    children: [
      // {
      //   path: '',
      //   redirectTo: 'consultar',
      //   pathMatch: 'full'
      // },
      {
        path: 'alterar-dados',
        loadChildren: () => import('./alterar-dados/alterar-dados.module').then(m => m.MovimentacaoModule)
      },
      {
        path: 'consultar',
        component: ConsultarComponent
      },
      {
        path: 'exclusao',
        loadChildren: () => import('./exclusao/exclusao.module').then(m => m.MovimentacaoModule)
      },
      {
        path: 'historico',
        component: HistoricoComponent
      },
      {
        path: 'cadastro-contrato-arrendamento',
        component: CadastroContratoArrendamentoComponent
      },
      {
        path: 'lista-contrato-arrendamento',
        component: HistoricoContratoArrendamentoComponent
      },
      {
        path: 'movimentacao',
        loadChildren: () => import('./movimentacao/movimentacao.module').then(m => m.MovimentacaoModule)
      }
    ]
  }
];
